module.exports = __webpack_public_path__ + "img/nijn.15aba7c7.svg";